import axios from "../../axiosConfig/axios";

export const UserProfile = {
    async addRejection(userdata) {
        return axios.patch(`users/${userdata?.user}?userId=${userdata?.id}&isAdmin=${true}`,
            {objection:userdata?.objection},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': userdata?.token
                }
            })

    },
    async approvedUser(data){
        return axios.post('admin/approve',{
            "approve": data?.key,
            "userId": data?.id,

        },{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': data?.token
            }
        })
    }
}